import { Product } from "../appData/productData"
import { useAppState } from "../context/appStateContext"
import PromoPricingInfo from "../models/promoPricingInfo"

interface ExistingUserPromoResult {
  pricing: PromoPricingInfo
  isDiscount: boolean
}

const useExistingUserPromo = (): ExistingUserPromoResult => {
  let isDiscount = true

  const productData = useAppState().state.productData!

  const longestSubscription = productData.longestUsedSubscription

  const premiumPlan = productData.premium

  // For yearly product - priority order:
  // 1. Longest subscription yearly product (if available)
  // 2. promo_yearly product (if available)
  // 3. Regular yearly product
  let yearlyProduct: Product

  if (longestSubscription) {
    yearlyProduct = longestSubscription.collection.premium.yearlyProduct
  } else {
    isDiscount = false

    // Look for promo_yearly product
    const promoYearlyProduct = productData.products.find(
      (product) => product.productId === "promo_yearly",
    )

    if (promoYearlyProduct) {
      yearlyProduct = promoYearlyProduct
    } else {
      yearlyProduct = premiumPlan.yearlyProduct
    }
  }

  // For monthly product - priority order:
  // 1. Longest subscription monthly product (if available)
  // 2. Regular monthly product
  const monthlyProduct = longestSubscription
    ? longestSubscription.collection.premium.monthlyProduct
    : premiumPlan.monthlyProduct

  return {
    pricing: PromoPricingInfo.fromYearlyAndMonthlyProduct(
      yearlyProduct,
      monthlyProduct,
      false,
      true,
    ),
    isDiscount,
  }
}

export default useExistingUserPromo
